<template>
  <div class="flex flex-col gap-4">
    <ComparisonTable
      :products-data="productsDataToCompare"
      :attributes="attributesToCompare"
      :current-sku="currentSku"
      :show-more="showMore"
    />
    <div
      v-if="showExpandButton"
      class="text-EXPONDO-secondary font-bold cursor-pointer w-full flex justify-center gap-8"
      @click="onClick"
    >
      <span>
        {{ showMore ? $t('Compare less attributes') : $t('Compare more attributes') }}
      </span>
      <span
        class="iconify svg--chevron-right"
        :class="showMore ? '-rotate-90' : 'rotate-90'"
      />
    </div>
  </div>
</template>

<script lang="ts">

import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import { getAttributesToCompare } from '~~/helpers/product/getAttributesToCompare';
import type { AttributesArray } from '~~/types/product/ComparisonProducts';
import type { AlternativeProductData } from '~~/types/product/AlternativeProducts';
import { DEFAULT_ATTRIBUTE_LIMIT } from '~~/constants/alternativeProducts';
import type { ProductProcessedAttributes } from '~~/types/product/attribute/ProductProcessedAttributes';

export default defineComponent({
  name: 'ComparisonProducts',

  props: {
    currentProduct: {
      type: Object as PropType<ProductVariantExtended>,
      required: true,
    },
    currentAttributesLocalized: {
      type: Object as PropType<ProductProcessedAttributes>,
      required: true,
    },
    comparisonProductsData: {
      type: Array as PropType<AlternativeProductData[]>,
      required: true,
    },
  },
  setup(props) {

    const showMore = ref(false);

    const currentSku = computed<string>(() => {

      return props.currentProduct.sku;
    
    });

    const productsDataToCompare = computed<AlternativeProductData[]>(() => {

      const currentProductData: AlternativeProductData = {
        product: props.currentProduct,
        attributesLocalized: props.currentAttributesLocalized,
      };

      return [currentProductData, ...props.comparisonProductsData];
    
    });

    const attributesToCompare = computed<AttributesArray>(() => getAttributesToCompare(productsDataToCompare.value));

    const showExpandButton = computed<boolean>(() => {

      return attributesToCompare.value.length > (DEFAULT_ATTRIBUTE_LIMIT);
    
    });

    const onClick = () => {

      showMore.value = !showMore.value;
    
    };

    return {
      productsDataToCompare,
      attributesToCompare,
      showMore,
      currentSku,
      showExpandButton,
      onClick,
    };
  
  },
});


</script>
